import {RemoteValue} from "../util/RemoteValue";
import {getOrSet} from "../util/MapUtil";
import api from "../util/api";
import {onRoleChange} from "../util/access/onRoleChange";


class CachedImageStore {
    private _cache = new Map<string, RemoteValue<string | undefined>>();

    get(serverUrl: string | undefined): RemoteValue<string | undefined> {
        return serverUrl === undefined
            ? RemoteValue.fromValue(undefined)
            : getOrSet(this._cache, serverUrl, () => new RemoteValue(async () => {
                const blob = await CachedImageStore.fetchApiImage(serverUrl);
                return blob && URL.createObjectURL(blob);
            }));
    }

    async clear() {
        for (const objectUrlRV of this._cache.values()) {
            const objectUrl = await objectUrlRV.value;
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        }
        this._cache.clear();
    }

    private static async fetchApiImage(url: string): Promise<Blob | undefined> {
        try {
            return (await api.get(url, {responseType: 'blob'})).data
        } catch (e) {
            console.error("Failed to fetch api image", e);
            return undefined;
        }
    }

}

export const cachedImageStore = new CachedImageStore();

onRoleChange(() => cachedImageStore.clear());